<template>
  <!-- вчера было потрачено 60 минут -->
  <BaseModal
    name="companyScore"
    width="1280"
    height="auto"
    :clickToClose="false"
    :adaptive="true"
    :scrollable="true"
    classes="!tw-bg-transparent !tw-shadow-none !tw-h-auto"
  >
    <div
      class="tw-bg-white tw-rounded-[25px] tw-pt-[20px] tw-px-[30px] tw-pb-[25px] tw-relative tw-text-forText tw-text-[14px]"
    >
      <button
        type="button"
        class="btn-close tw-absolute tw-right-[30px] tw-top-[20px] !tw-shadow-none"
        @click="$modal.hide('companyScore')"
      ></button>

      <div>
        <div if="!ratingDetails">
          <div
            class="tw-text-[18px] tw-font-semibold tw-text-black tw-leading-[125%]"
          >
            Баллы - это ваша экономия
          </div>
        </div>

        <div class="tw-flex tw-gap-[15px] tw-mt-[10px] tw-mb-[15px]">
          <div class="tw-flex-1">
            <div
              class="tw-border-[#E3F0FF] tw-border-solid tw-border-[1px] tw-rounded-[8px] tw-py-[10px] tw-px-[20px] tw-mb-[15px]"
            >
              <div
                class="tw-flex tw-gap-[15px] tw-text-[#023F8F] tw-text-[24px]"
              >
                <img
                  :src="require(`@/assets/icons/company-score/star-circle.svg`)"
                  class="tw-w-[32px]"
                />
                1 балл = 1 рубль
              </div>
            </div>

            <div
              class="tw-border-[#E3F0FF] tw-border-solid tw-border-[1px] tw-rounded-[8px] tw-p-[20px]"
            >
              <div class="tw-leading-[123%] tw-text-[18px] tw-text-forTitle">
                <div class="tw-mb-[15px]">
                  Покупайте товары и услуги через Сириус и получайте 1%
                  стоимости обратно баллами.
                </div>
                <div class="tw-mb-[15px]">
                  Баллами можно оплачивать GPS-мониторинг, скоринг клиентов и
                  большинство платных функций платформы.
                </div>
                <div class="tw-mb-[15px]">Но это только часть выгоды.</div>
                <div class="tw-mb-[10px]">
                  Все автопарки регулярно покупают страховки, запчасти, шины,
                  услуги СТО, кузовной ремонт и многое другое. Заказывая
                  напрямую у поставщика, вы получаете обычную рыночную цену.
                  Заказывая у этого же поставщика через Сириус, вы получаете
                  сразу три преимущества:
                </div>
                <div class="tw-flex tw-gap-[10px] tw-items-center tw-mb-[10px]">
                  <img
                    :src="require(`@/assets/icons/company-score/1.svg`)"
                    class="tw-w-[32px]"
                  />
                  Корпоративную цену, согласованную специально для пользователей
                  Сириус.
                </div>
                <div class="tw-flex tw-gap-[10px] tw-items-center tw-mb-[10px]">
                  <img
                    :src="require(`@/assets/icons/company-score/2.svg`)"
                    class="tw-w-[32px]"
                  />
                  Дополнительный контроль качества. Если поставщик подведет хотя
                  бы одного пользователя Сириус, он рискует потерять крупный
                  канал продаж.
                </div>
                <div class="tw-flex tw-gap-[10px] tw-items-center tw-mb-[15px]">
                  <img
                    :src="require(`@/assets/icons/company-score/3.svg`)"
                    class="tw-w-[32px]"
                  />
                  Кешбэк 1% баллами, который можно использовать для оплаты
                  других сервисов платформы.
                </div>
                <div class="tw-mb-[15px]">
                  Если проводить обслуживание автопарка через поставщиков
                  Сириус, накопленных баллов будет достаточно, чтобы полностью
                  или частично оплачивать сервисы платформы. Для многих компаний
                  это означает бесплатный GPS-мониторинг и экономию десятков, а
                  иногда и сотен тысяч рублей в год.
                </div>
                <div class="tw-font-[600]">
                  Обслуживайте свой парк через Сириус — платите меньше,
                  получайте больше.
                </div>
              </div>
            </div>
          </div>

          <div
            class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center tw-border-[#F5F5F5] tw-bg-[#97C901] tw-text-white tw-w-[300px] tw-border-solid tw-border-[1px] tw-rounded-[8px]"
          >
            <div class="tw-text-[32px] tw-mb-[10px]">У вас</div>
            <div class="tw-bg-[#B5E61D] tw-py-[30px] tw-px-[5px] tw-w-full">
              <div class="tw-text-[64px] tw-leading-[65px] tw-font-[600]">
                {{ aboutUser?.company_score?.replace(".", ",") }}
              </div>
              <div class="tw-text-[32px] tw-leading-[30px]">баллов</div>
            </div>
            <div class="tw-text-[18px] tw-leading-[125%] tw-mt-[30px]">
              Баллами можно<br />
              оплачивать GPS-<br />мониторинг, скоринг<br />
              клиентов и большинство<br />
              платных функций<br />
              платформы
            </div>
          </div>
        </div>

        <div class="tw-flex tw-justify-between tw-items-center tw-text-[12px]">
          <div class="tw-flex tw-gap-[15px] tw-items-center">
            <div
              class="tw-inline-flex tw-bg-[#F1F3F5] tw-p-[6px] tw-rounded-full"
            >
              <img
                :src="
                  require(`@/assets/icons/status-rating/question-circle.svg`)
                "
                class="tw-max-w-[20px] tw-max-h-[20px]"
              />
            </div>

            <div>
              Есть вопросы?
              <a
                href="mailto:support@sirius.rent"
                class="!tw-text-[#023F8F] hover:tw-underline"
              >
                Свяжитесь с поддержкой
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import TableRating from "@/components/TableRating.vue";

export default {
  props: ["aboutUser", "fixedCompanyRating", "rawCompanyRating"],
  components: {
    TableRating,
  },
  data() {
    return {
      ratingDetails: false,
      howWork: [
        {
          icon: "arrow-top.svg",
          bg: "#EDF7F0",
          title: "Рейтинг повышается",
          desc: "За успешные заказы, хорошие оценки, активность и соблюдение правил",
        },
        {
          icon: "arrow-bottom.svg",
          bg: "#FFC8C8",
          title: "Рейтинг понижается",
          desc: "За отказы, отмены, жалобы, просрочки и нарушения правил",
        },
        {
          icon: "info.svg",
          bg: "#EEF4FA",
          title: "Обновление рейтинга",
          desc: "Рейтинг пересчитывается ежедневно на основе активности и качества работы",
        },
      ],
      statuses: [
        {
          color1: "#FFC8C8",
          color2: "#FF3A20",
          title: "Блокировка",
          iconTitle: "blocked.svg",
          list: ["Заявки недоступны"],
          iconList: "blocked2.svg",
          value: 0,
        },
        {
          color1: "#FFF5D9",
          color2: "#BF8E00",
          title: "Ограниченный",
          iconTitle: "limited.svg",
          list: [
            "Ограниченный поток заявок",
            "Заявки от операторов аренды - 4-й приоритет",
            "Без заявок от агрегаторов",
          ],
          iconList: "limited2.svg",
          value: "1-39",
          minimumCommission: "30%",
        },
        {
          color1: "#E3F0FF",
          color2: "#023F8F",
          title: "Базовый",
          iconTitle: "base.svg",
          list: [
            "Базовый поток заявок",
            "Заявки от операторов аренды - 3-й приоритет",
            "Заявки от агрегаторов -<br> 3-й приоритет",
          ],
          iconList: "base2.svg",
          value: "40-59",
          minimumCommission: "23%",
        },
        {
          color1: "#EDF7F0",
          color2: "#23B14D",
          title: "Профессионал",
          iconTitle: "professional.svg",
          list: [
            "Основной поток заявок",
            "Заявки от операторов аренды 2-й приоритет",
            "Заявки от агрегаторов -<br> 2-й приоритет",
          ],
          iconList: "professional2.svg",
          value: "60-84",
          minimumCommission: "22%",
        },
        {
          color1: "#F2E3FF",
          color2: "#8000FF",
          title: "Эксперт",
          iconTitle: "expert.svg",
          list: [
            "Максимальный поток заявок ",
            "Заявки от операторов аренды - 1-й приоритет",
            "Заявки от агрегаторов -<br> 1-й приоритет",
          ],
          iconList: "expert2.svg",
          value: "85-100",
          minimumCommission: "20%",
        },
      ],
    };
  },
  computed: {
    ...mapState("translationModule", ["dataLang"]),
    fixedCompanyRating_info() {
      if (this.fixedCompanyRating == 0) {
        return {
          color1: "#FFC8C8",
          color2: "#FF3A20",
          icon: "blocked.svg",
        };
      }
      if (this.fixedCompanyRating >= 1 && this.fixedCompanyRating <= 39) {
        return {
          color1: "#FFF5D9",
          color2: "#BF8E00",
          icon: "limited.svg",
        };
      }
      if (this.fixedCompanyRating >= 40 && this.fixedCompanyRating <= 59) {
        return {
          color1: "#E3F0FF",
          color2: "#023F8F",
          icon: "base.svg",
        };
      }
      if (this.fixedCompanyRating >= 60 && this.fixedCompanyRating <= 84) {
        return {
          color1: "#EDF7F0",
          color2: "#23B14D",
          icon: "professional.svg",
        };
      }
      if (this.fixedCompanyRating >= 85) {
        return {
          color1: "#F2E3FF",
          color2: "#8000FF",
          icon: "expert.svg",
        };
      }
      return null;
    },
  },
};
</script>

<style lang="scss">
.table-type-1 {
  table,
  th,
  td {
    border: 1px solid #e3f0ff;
    padding: 10px 30px;
  }
}
</style>
